import type { ConceptDef } from '../types';

export const brushingTeeth: ConceptDef = {
  kind: 'sequenceTap',
  id: 'brushing-teeth',
  label: 'Brushing Teeth Steps',
  category: 'Daily living',
  description: 'Tap brushing-teeth steps in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Brush your teeth.', items: ['💧 wet brush', '🪥 add paste', '😬 brush', '💦 rinse'] },
    ],
  },
};
